import { render, staticRenderFns } from "./SettingsMobileApp.vue?vue&type=template&id=0cdf9727&scoped=true"
import script from "./SettingsMobileApp.vue?vue&type=script&lang=js"
export * from "./SettingsMobileApp.vue?vue&type=script&lang=js"
import style0 from "./SettingsMobileApp.vue?vue&type=style&index=0&id=0cdf9727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdf9727",
  null
  
)

export default component.exports